var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoupeLeftSide = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13 7A6 6 0 1 1 1 7a6 6 0 0 1 12 0m-1.41 5.286a7 7 0 1 1 .696-.696 1 1 0 0 1 .068.056l3.5 3.5a.5.5 0 0 1-.708.708l-3.5-3.5a1 1 0 0 1-.057-.068z",
  clipRule: "evenodd"
})));
export default SvgLoupeLeftSide;